// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tc-0";
export var checkoutRateBadgeLink = "_tc-1";